var compPosts = Vue.component('posts', {

    template: '#posts-comp',
    parent: compQuestao,
    ready: function(){
        var self = this;
        this.questaoId = this.$parent.id;
        this.carregaPosts(true);
    },
    props: {
        tipo        : String,
        nome        : String,
        plural      : String
    },
    data: function () {
        return {
            editoresIniciados           : {},
            posts                       : {},
            questaoId                   : -1,
            usuarioLogadoId             : -1,
            campoOrdenacao              : 'somaVotos', /* somaVotos OU id */
            maisVotadoOuRecente         : 'Votos',
            mostrarTodosComentarios     : true,
            comentando                  : -1,
            respondendo                 : -1,
            editando                    : -1, 
            editandoUrl                 : '', 
            editandoDescricao           : '', 
            destacado                   : -1,
            editorVisivel               : false,
            novoPost                    : {
                conteudo    : '',
                descricao   : ''
            },
            postando                    : false,
            postandoComentario          : false,
            postandoResposta            : false,
            postsACarregar              : 0,
            carregandoPosts             : false,
            carregandoMaisComentarios   : false,
            carregandoMaisRespostas     : false,
            maisOpcoes                  : -1,
            tipoMaterial                : null
        }
    },
    methods: {
        objVazio: function ( obj ) {
            return objSize(obj) == 0;
        },
        selecionaTipoMaterial: function ( material ) {

            this.tipoMaterial = material;
            var input = $('#materiais' + this.questaoId + '-input');

            input.removeAttr('disabled');

            Vue.nextTick(function () {
                input.focus();
            });
        },
        carregaPosts: function ( do_inicio ) {

            var carregados = do_inicio ? 0 : this.postsCarregados;

            var url = '';
            var self = this;
            switch( this.tipo ){
                case 'resolucoes':
                    url = '/questao/resolucoes/carregar';
                    break;
                case 'discussoes':
                    url = '/questao/discussoes/carregar';
                    break;
                case 'materiais':
                    url = '/questao/materiais/carregar';
            }

            this.carregandoPosts = true;
            this.editorVisivel = false;

            if( do_inicio ){
                self.$parent.carregando[self.tipo] = true;
                Vue.set(self, 'posts', {});
                Vue.set(self, 'editoresIniciados', {});
                tinymce.editors = [];
                fechaTooltips();
            }

            ajaxGET(
                url,
                {
                    questaoId   : self.questaoId,
                    ordenarPor  : self.campoOrdenacao,
                    carregados  : carregados
                },
                self.concluiCarregamento
            );

        },
        concluiCarregamento: function( dados ) {
            
            for(var id in dados.posts){
                Vue.set(this.posts, id, dados.posts[id]);
            }

            this.usuarioLogadoId = dados.usuarioLogadoId;
            this.postsACarregar = dados.postsACarregar;
            this.$parent.carregando[this.tipo] = false;

            this.processaMathJax(true);
            this.carregandoPosts = false;
        },
        exibirEditor: function ( textarea_id, tipo, novo_post, conteudo ) {

            if( tipo == 'materiais' ){
                this.editorVisivel = true;
            }
            
            var toolbar, self = this;
            var seletor = textarea_id + '';
            if( tipo == 'resolucoes') {
                toolbar = 'bold italic underline strikethrough | blockquote styleselect | ';
                toolbar += 'alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | ';
                toolbar += 'link image imageupload | charmap asciimath4';
            }
            else if( tipo == 'discussoes' ) {
                toolbar = 'bold italic underline strikethrough | blockquote | alignleft aligncenter alignright ';
                toolbar += 'alignjustify | bullist numlist outdent indent | link | charmap asciimath4';
            }
            else {
                toolbar = 'bold italic underline strikethrough | blockquote | bullist numlist outdent indent | ';
                toolbar += 'link | charmap asciimath4';
            }

            if( novo_post ){
                this.editorVisivel = true;
            }

            Vue.nextTick(function(){

                tinymce.init({
                    selector                    : seletor,
                    auto_focus                  : seletor.replace(/#/g , ""),
                    language                    : 'pt_BR',
                    menubar                     : false,
                    keep_styles                 : false,
                    plugins                     : 'asciimath4 link image charmap table autoresize',
                    toolbar                     : toolbar,
                    file_picker_callback        : function(callback, value, meta) {
                        if( meta.filetype == 'image') $('#input_upload_imagem').click();
                    },
                    relative_urls               : false,
                    autoresize_bottom_margin    : 0,
                    autoresize_min_height       : 60,
                    autoresize_max_height       : 500,
                    image_dimensions            : false,
                    image_description           : false,
                    image_title                 : false,
                    image_class_list            : [
                        {title: 'Imagem (.jpg ou .png) até 1MB', value: 'imagem-post'}
                    ]
                });
            });
            
        },
        imageFilePicker: function (callback, value, meta) {
            tinymce.activeEditor.windowManager.open({
                title: 'Image Picker',
                url: '/questao/upload-imagem',
                width: 500,
                height: 400,
                buttons: [
                    {
                        text: 'Inserir',
                        onclick: function () {
                            //.. do some work
                            tinymce.activeEditor.windowManager.close();
                        }
                    },
                    {
                        text: 'Cancelar',
                        onclick: 'close'
                    }
                ]
            },
            {
                oninsert: function (url) {
                    callback(url);
                    console.log("derp");
                }
            });
        },
        cancelarNovoPost: function () {
            this.editorVisivel = false;
            this.novoPost.conteudo = '';
            this.postando = false;
        },
        criarPost: function ( ) {

            if( !this.postValido ){
                console.log('!postValido');
                return false;
            }
            
            var conteudo = '';
            switch ( this.tipo ){
                case 'materiais':
                    conteudo = this.novoPost.conteudo;
                    break;
                case 'resolucoes':
                    conteudo = tinymce.get('resolucoes' + this.questaoId).getContent();
                    break;
                case 'discussoes':
                    conteudo = tinymce.get('discussoes' + this.questaoId).getContent();
            }

            /* Editor vazio => Só retorna */
            if( !conteudo.trim() || (conteudo.trim() == '<p><brdata-mce-bogus="1"></p>') ){
                console.log('get: ', tinymce.get('discussoes' + this.questaoId));
                console.log('editores: ', tinymce.editors);
                return false;
            }

            this.postando = true;

            ajaxPOST(
                '/questao/post/criar',
                {
                    questaoId   : this.questaoId,
                    tipo        : this.tipo,
                    conteudo    : conteudo,
                    descricao   : this.novoPost.descricao,
                    tipoMaterial: this.tipoMaterial
                },
                this.adicionaNovoPost
            );
        },
        atualizaComentario: function (comentario) {

            // É uma resposta!
            if( comentario.comentarioPai ){

                this.posts[comentario.postPai].comentarios[comentario.comentarioPai].respostas[comentario.id].conteudo = comentario.conteudo;
                this.postandoResposta = false;

            }else{ // É um comentario!
                
                this.posts[comentario.postPai].comentarios[comentario.id].conteudo = comentario.conteudo;
                this.postandoComentario = false;
            }

            this.editando = -1;
            this.processaMathJax();
        },
        atualizaPost: function (dados) {

            var post = JSON.parse(dados);

            this.posts[post.id].conteudo = post.conteudo;
            this.posts[post.id].descricao = post.descricao;

            this.editando = -1;
            this.postando = false;

            this.processaMathJax();
        },
        adicionaNovoPost: function ( post ) {

            Vue.set( this.posts, post.id, post );

            this.postando = false;
            this.novoPost.conteudo = '';
            this.novoPost.descricao = '';
            this.editorVisivel = false;
            if( this.tipo == 'resolucoes' || this.tipo == 'discussoes' ){
                tinymce.get(this.tipo + this.questaoId).setContent('');
            }

            // forçando o novo post ficar no topo!
            // postsCarregados atualizado automaticamente (computed property)
            if( this.campoOrdenacao == 'somaVotos' ){
                this.alteraOrdenacao('recentes');
            }

            this.$parent.tabs[ this.tipo ]++;
            this.processaMathJax(true);
        },
        editarMaterial: function ( post_id, conteudo, descricao ) {

            var editor = this.tipo + '-' + post_id;

            // Faz toggle no botao editar
            if( this.editando == editor ){
                return this.editando = -1;
            }

            var url = conteudo;

            url = url.replace('youtube.com/embed/', 'youtube.com/watch?v=');
            this.editandoUrl = url.replace('vimeo.com/video/', 'vimeo.com/');
            this.editandoDescricao = descricao;

            this.editando = editor;
        },
        salvaNovaDescricao: function ( post_id ) {

            var self = this;
            this.postando = true;

            Vue.nextTick(function(){

                ajaxPOST(
                    'questao/post/atualizar',
                    {
                        postId      : post_id,
                        tipo        : self.tipo,
                        descricao   : self.editandoDescricao
                    }
                );

                self.posts[post_id].descricao = self.editandoDescricao;
                self.postando = false;
                self.editando = -1;
            });
            
        },    
        editar: function ( tipo, id, conteudo ) {

            var self = this;
            var editor = tipo + '-' + id;

            // Faz toggle no botao editar
            if( this.editando == editor ){
                return this.editando = -1;
            }
            
            if( this.editoresIniciados[editor] ){
                this.editando = editor;
                return;
            }

            Vue.set(this.editoresIniciados, editor, true);
            this.editando = editor;

            Vue.nextTick(function(){
                self.exibirEditor('#editor-'+editor, tipo, false, conteudo);
            });

        },
        salvaEdicao: function ( tipo, id ) {

            switch( tipo ){
                case 'comentario':
                    this.postandoComentario = true;
                    this.atualizarComentario( 'comentario', id );
                    break;
                case 'resposta':
                    this.postandoResposta = true;
                    this.atualizarComentario( 'resposta', id );
                    break;
                default:
                    this.postando = true;
                    this.atualizarPost( id );
                    break;
            }

        },
        excluir: function ( post_id, comentario_id, resposta_id ) {

            var url = '/questao/comentarios/excluir';
            var msg = 'Deseja mesmo excluir o seu comentário<br> e todas respostas associadas?';
            var id = post_id;

            if( !comentario_id && !resposta_id ){
                url = '/questao/post/excluir';
                msg = 'Deseja mesmo exluir a sua postagem<br> e todos comentários associados?'
            }

            confirma(
                msg,
                this.exclusaoConfirmada,
                {url: url, postId: post_id, comentarioId: comentario_id, respostaId: resposta_id}
            );
        },
        exclusaoConfirmada: function ( dados ) {

            var self = this;
            var id = dados.postId;

            // é um post
            if( !dados.comentarioId && !dados.respostaId ){
                Vue.delete(this.posts, dados.postId);
                this.$parent.tabs[ this.tipo ]--;
            }

            // é um comentário
            if( dados.comentarioId && !dados.respostaId ){
                Vue.delete(this.posts[dados.postId].comentarios, dados.comentarioId);
                id = dados.comentarioId;
            }

            // é uma resposta
            if( dados.comentarioId && dados.respostaId ){
                Vue.delete(this.posts[dados.postId].comentarios[dados.comentarioId].respostas, dados.respostaId);
                id = dados.respostaId;

                /* Apaga as respostas à resposta que foi excluída */
                for( var r_id in this.posts[dados.postId].comentarios[dados.comentarioId].respostas ){
                    if( self.posts[dados.postId].comentarios[dados.comentarioId].respostas[r_id].respondendoId == dados.respostaId ){
                        Vue.delete(
                            self.posts[dados.postId].comentarios[dados.comentarioId].respostas,
                            r_id
                        );
                    }
                }
            }

            ajaxPOST(
                dados.url,
                { id: id, tipo: this.tipo }
            );

        },
        salvarVerDepois: function (post_id) {

            ajaxPOST(
                '/questao/post/salvar-ver-depois',
                {
                    postId  : post_id,
                    tipo    : this.tipo
                }
            );
        },
        /* ATENÇÃO!! Depois que carregam os comentários do BD, a contagem de votos que
        * o usuário verá já não reflete mais o que está no BD. Por exemplo, se o comentário
        * X tinha 10 votos quando ele carregou, após o usuário votar ele verá sempre 11,
        * independente de ter sido computado outros 50 votos nesse intervalo.
        * Isso foi uma opção minha, porque evita casos de súbitos saltos nos votos, e reordenação.
        * */
        votar: function (upDown, post_id, comentario_id, resposta_id ) {

            var alvo = this.posts[post_id];
            if( comentario_id && resposta_id ){
                alvo = this.posts[post_id].comentarios[comentario_id].respostas[resposta_id];
            }
            else if( comentario_id ){
                alvo = this.posts[post_id].comentarios[comentario_id];
            }

            /* Calma, pequeno gafanhoto! */
            if( alvo.aguardandoAjax ){
                return false;
            }

            alvo.aguardandoAjax = upDown;

            ajaxPOST(
                '/questao/post/votar',
                {
                    tipo            : this.tipo,
                    postId          : post_id,
                    comentarioId    : comentario_id,
                    respostaId      : resposta_id,
                    upDown          : upDown
                },
                this.votacaoEfetuada
            );

        },
        votacaoEfetuada: function (dados) {

            var post_id = dados.postId;
            var comentario_id = dados.comentarioId;
            var resposta_id = dados.respostaId;
            var upDown = dados.upDown;

            var alvo = this.posts[post_id];
            if( comentario_id ){
                alvo = alvo.comentarios[comentario_id];
            }
            if( resposta_id ){
                alvo = alvo.respostas[resposta_id];
            }

            var voto = 'votosUp';
            var oposto = 'votosDown';
            if( upDown == 'down' ){
                voto = 'votosDown';
                oposto = 'votosUp';
            }

            /* Trocando o voto? Subtrai do antigo */
            if( alvo.meuVoto && (alvo.meuVoto != upDown) ){
                alvo[oposto]--;
            }

            /* Apenas revogando o voto? */
            if( alvo.meuVoto && (alvo.meuVoto == upDown) ){
                alvo[voto]--;
                alvo.meuVoto = null;
            }else{
                alvo[voto]++;
                alvo.meuVoto = upDown;
            }

            alvo.somaVotos = alvo.votosUp - alvo.votosDown;
            alvo.aguardandoAjax = false;
        },
        criarComentario: function ( post_pai, comentario_pai, respondendo ) {

            var conteudo = tinymce.activeEditor.getContent();
            if( comentario_pai ){
                this.postandoResposta = true;
            }else{
                this.postandoComentario = true;
            }

            ajaxPOST(
                '/questao/comentarios/criar',
                {
                    questaoId       : this.questaoId,
                    post            : this.tipo,
                    conteudo        : conteudo,
                    postPai         : post_pai,
                    comentarioPai   : comentario_pai,
                    respondendo     : respondendo
                },
                this.adicionaNovoComentario
            );

        },
        atualizarPost: function ( post_id ) {

            var conteudo = tinymce.get('editor-' + this.tipo + '-' + post_id).getContent();

            ajaxPOST(
                '/questao/post/atualizar',
                {
                    postId      : post_id,
                    tipo        : this.tipo,
                    conteudo    : conteudo
                }
            );

            this.posts[post_id].conteudo = conteudo;

            this.editando = -1;
            this.postando = false;

            this.processaMathJax();

        },
        atualizarComentario: function ( tipo, id ) {

            var conteudo = tinymce.get('editor-' + tipo + '-' + id).getContent();

            ajaxPOST(
                '/questao/comentarios/atualizar',
                { id: id, conteudo: conteudo },
                this.atualizaComentario
            );

        },
        adicionaNovoComentario: function ( comentario ) {

            // É um comentário!
            if( comentario.hasOwnProperty('respostas') ){
                Vue.set(
                    this.posts[comentario.postPai].comentarios,
                    comentario.id,
                    comentario
                );
                this.postandoComentario = false;
                this.comentando = -1;

            }else{ // É uma resposta!
                Vue.set(
                    this.posts[comentario.postPai].comentarios[comentario.comentarioPai].respostas,
                    comentario.id,
                    comentario
                );
                this.postandoResposta = false;
                this.respondendo = -1;
            }

            this.processaMathJax(true);
        },
        alteraOrdenacao: function ( ordenarPor ) {

            var recarregar = false;
            var campoOrdenacaoAnterior = this.campoOrdenacao;
            this.campoOrdenacao = (ordenarPor == 'recentes') ? 'id' : 'somaVotos';
            this.maisVotadoOuRecente = (ordenarPor == 'recentes') ? 'Recentes' : 'Votos';

            /* Verifica se mudou a ordenação e tem mais coisa a carregar do BD */
            if( campoOrdenacaoAnterior != this.campoOrdenacao ){

                // posts a carregar?
                recarregar = this.postsACarregar > 0;

                if( !recarregar ){
                    // comentarios a carregar?
                    for(var id in this.posts){
                        if( recarregar = (this.posts[id].comentariosACarregar > 0) ){
                            break; // sai do for de comentários
                        }
                        // respostas a carregar?
                        for(var cId in this.posts[id].comentarios){
                            if( recarregar = (this.posts[id].comentarios[cId].respostasACarregar > 0) ){
                                break; // sai do for de respostas
                            }
                        }
                        if( recarregar ){
                            break; // sai do for de comentários
                        }
                    }
                }
            }

            if( recarregar ){
                this.$parent.carregando[this.tipo] = true;
                this.posts = {};

                var self = this;
                Vue.nextTick(function(){
                    self.carregaPosts(true);
                });
            }
        },
        responder: function ( id, eh_post ) {

            /* Clicar em 'responder' faz toggle: tanto abre quanto fecha o <input> */
            if( !eh_post && (this.respondendo == id) ){
                return this.respondendo = -1;
            }

            if( eh_post && (this.comentando == id) ){
                return this.comentando = -1;
            }

            var idPrefix = '#input-responder-';
            if( eh_post ){
                this.comentando = id;
                idPrefix = '#input-comentar-';
            }else{
                this.respondendo = id;
            }

            var self = this;

            Vue.nextTick(function(){
                self.exibirEditor(idPrefix + id, 'comentario', false);
            });
        },
        carregarMaisComentarios: function ( post_pai ) {

            this.carregandoMaisComentarios = true;

            ajaxGET(
                '/questao/comentarios/carregar',
                {
                    nomePost                : this.tipo,
                    ordenarPor              : this.campoOrdenacao,
                    jaCarregado             : this.posts[post_pai].comentariosCarregados, /* faz skip */
                    postPai                 : post_pai,
                    comentariosOuRespostas  : 'comentarios'
                },
                this.incluiMaisComentarios
            );
          
        },
        incluiMaisComentarios: function( dados ) {

            for( var id in dados.comentarios ){
                Vue.set(this.posts[dados.postPai].comentarios, id, dados.comentarios[id]);
            }
            this.posts[dados.postPai].comentariosCarregados += dados.comentariosCarregados;
            this.posts[dados.postPai].comentariosACarregar = dados.comentariosACarregar;

            this.carregandoMaisComentarios = false;
            this.processaMathJax(true);
        },
        carregarMaisRespostas: function ( post_pai, comentario_pai ) {

            this.carregandoMaisRespostas = true;

            ajaxGET(
                '/questao/comentarios/carregar',
                {
                    nomePost                : this.tipo,
                    ordenarPor              : this.campoOrdenacao,
                    jaCarregado             : this.posts[post_pai].comentarios[comentario_pai].respostasCarregados,
                    postPai                 : post_pai,
                    comentarioPai           : comentario_pai,
                    comentariosOuRespostas  : 'respostas'
                },
                this.incluiMaisRespostas
            );

        },
        incluiMaisRespostas: function( dados ) {

            for( var id in dados.respostas ){
                Vue.set(this.posts[dados.postPai].comentarios[dados.comentarioPai].respostas, id, dados.respostas[id]);
            }
            this.posts[dados.postPai].comentarios[dados.comentarioPai].respostasCarregados += dados.respostasCarregados;
            this.posts[dados.postPai].comentarios[dados.comentarioPai].respostasACarregar = dados.respostasACarregar;

            this.carregandoMaisRespostas = false;
            this.processaMathJax(true);
        },
        toggleTodosComentarios: function () {

            this.mostrarTodosComentarios = !this.mostrarTodosComentarios;

            for(var id in this.posts){
                this.posts[id].mostrarComentarios = this.mostrarTodosComentarios;
            }
        },
        possiveisProblemas: function () {

            var problemas = {
                titulo  : 'Relatar Problema em ' + this.nome,
                opcoes  : []
            };

            var quebrado = { valor: 'quebrado', texto: 'Link de ' + this.nome + ' Quebrado/Inválido' };
            var autoral = { valor: 'autoral', texto: 'É Plágio (Cópia)' };
            var ofensivo = { valor: 'ofensivo', texto: 'É Ofensivo/Inapropriado' };
            var spam = { valor: 'spam', texto: 'É SPAM' };
            var outro = { valor: 'outro', texto: 'Outro' };

            if( this.tipo == 'resolucoes' ){
                problemas.opcoes = [autoral, ofensivo, spam, outro];
            }else{
                problemas.opcoes = [quebrado, autoral, ofensivo, spam, outro];
            }

            return problemas;
        },
        relatarProblema: function ( post_id ) {
            
            vmRelatarProblema.problemas = this.possiveisProblemas();
            vmRelatarProblema.urlAjax = '/questao/post/relatar-problema';
            vmRelatarProblema.abrirModal( post_id, this.tipo );
        },
        marcarInapropriado: function (comentario_id) {
            confirma(
              'Deseja mesmo marcar este<br> comentário como inapropriado?',
                this.inapropriadoConfirmado,
                {comentarioId: comentario_id}
            );
        },
        inapropriadoConfirmado: function (dados) {

            ajaxPOST(
                '/questao/comentarios/reportar',
                { comentarioId: dados.comentarioId }
            );

        },
        processaMathJax: function ( inicializa_tooltips ) {

            Vue.nextTick(function(){
                MathJax.Hub.PreProcess();
                MathJax.Hub.Process();

                if( inicializa_tooltips ){
                    inicializaTooltips();
                }
            });

        }
        /*validaUrlVideo: function ( url ) {
            var expressao = /(((youtube\.com(\.br)?)|youtu\.?be)\/.+)|(vimeo\.com\/.+)/gi;
            var regex = new RegExp(expressao);

            if( url ){
                return url.match(regex);
            }

            return this.novoPost.conteudo.match(regex);
        }*/
    },
    computed: {
        postsCarregados: function () {
            var total = 0;
            for(var id in this.posts){
                total++;
            }

            return total;
        },
        postValido: function () {

            return true;
        },
        urlValido: function () {

            return true;
        }
    }

});